export default {
  type: "root",
  style: "",
  className: "",
  data: {
    tilte: "Landing Page",
    contentAreaWidth: 800,
  },
  id: "84885366-ca06-4566-9f33-8629fdf85773",
  children: [
    {
      type: "row",
      className: "",
      id: "eb05c713-caa9-461f-b741-dde7305006b6",
      data: {
        applyImageTo: "row",
        stackOnMobile: "off",
      },
      children: [
        {
          type: "col",
          className: "rip-mm-col rip-mm-col-md-12",
          id: "b8240777-3da5-4eee-8659-685e04b495c0",
          children: [],
        },
      ],
    },
  ],
};
